import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AidaEligibility } from '@ps/survey-utils';

import { AidaApi } from '../../api/aida/aida.api';

@Injectable({ providedIn: 'root' })
export class AidaService {
  private readonly _api = inject(AidaApi);

  public eligibilityCheck(surveyId: number): Observable<AidaEligibility> {
    return this._api.eligibilityCheck(surveyId);
  }
}
